import React, { useCallback } from 'react';
import { IPageData } from '../../../../types/rest/IPageData';
import { IPCDashboardTaskData } from '../../../../types/pcDashboard/IDashboardTasks';
import { useGetTaskColumns } from './hooks/useGetTasksColumns';
import { useDeterminePagination } from '../../util/tableUtilityMethods';
import { ITableChangeState } from 'react-bootstrap-table-next';
import { CardSection } from '@zillow/constellation';
import { ISortedBy } from '../../../../ui-toolkit';
import { FromToTotalConstellation } from '../signingAppointments/FromToTotal';
import { useHasFeatureFlag } from '../../../../selectors/useHasFeatureFlag';
import { TaskPaginationSortParams } from './hooks/useManageTaskPagination';
import { getSpruceRowClasses, StyledSpruceDataGrid } from '../../util/spruceOrderIndicator';

const defaultSorted: ISortedBy[] = [{ dataField: 'dueDate', order: 'desc' }];

export const TasksTable: React.FC<{
  data: IPageData<IPCDashboardTaskData>;
  isFetching: boolean;
  isSuccess: boolean;
  setTaskPaginationSortParams: React.Dispatch<React.SetStateAction<TaskPaginationSortParams>>;
}> = ({ data, isFetching, isSuccess, setTaskPaginationSortParams }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const columns = useGetTaskColumns();
  const pagination = useDeterminePagination(data);
  const onTableChange = useCallback(
    (type: string, tableState: ITableChangeState<IPCDashboardTaskData>) => {
      if (isFetching || !isSuccess) {
        // wait until the data exists before we try setting the QueryString
        return;
      }
      setTaskPaginationSortParams({
        page: tableState.page - 1,
        size: tableState.sizePerPage,
        sort: tableState.sortOrder,
        sortProperty: tableState.sortField,
      });
    },
    [isFetching, isSuccess, setTaskPaginationSortParams]
  );
  return (
    <CardSection>
      <StyledSpruceDataGrid
        columns={columns}
        keyField={'taskId'}
        data={data.content}
        remote
        loading={isFetching}
        pagination={pagination}
        onTableChange={onTableChange}
        defaultSorted={defaultSorted}
        zIndex="10"
        rowClasses={(row: IPCDashboardTaskData, rowIndex: number) =>
          getSpruceRowClasses(row, rowIndex, isZillowClosingEnabled)
        }
      />
      <FromToTotalConstellation
        pageSize={data.pageSize}
        pageNumber={data.pageNumber}
        totalElements={data.totalElements}
      />
    </CardSection>
  );
};
